import EsignatureStartupView from '@Views/EsignatureStartupView.vue';
import EsignatureEnvelopeView from '@Views/EsignatureEnvelopeView.vue';
import RequestCanceledView from '@Views/RequestCanceledView.vue';
import RequestVoidedView from '@Views/RequestVoidedView.vue';
import GetStartedView from '@Views/GetStartedView.vue';
import WhatsNextView from '@Views/WhatsNextView.vue';
import ReviewDocumentView from '@Views/ReviewDocumentView.vue';
import EsignatureCompleteView from '@Views/EsignatureCompleteView.vue';
import EsignatureFinishLaterView from '@Views/EsignatureFinishLaterView.vue';
import EsignatureRecipientDeclineView from '@Src/views/EsignatureRecipientDeclineView.vue';
import EsignatureRequestDeclineView from '@Src/views/EsignatureRequestDeclineView.vue';
import EsignatureSubmitView from '@Src/views/EsignatureSubmitView.vue';
import EsignatureErrorView from '@Src/views/EsignatureErrorView.vue';
import EsignatureSuccessView from '@Views/EsignatureSuccessView.vue';
import ManualReviewView from '@Src/views/ManualReviewView.vue';


export const createRoutes = (basePath: string) => {
    return [
        {
            path: `${basePath}/esignature/:token`,
            name: 'get-started',
            component: GetStartedView,
        },
        {
            path: `${basePath}/esignature/whats-next`,
            name: 'whats-next',
            component: WhatsNextView,
        },
        {
            path: `${basePath}/esignature/startup`,
            name: 'startup',
            component: EsignatureStartupView,
            meta: { bootstrap: true },
        },
        {
            path: `${basePath}/esignature/prepare`,
            name: 'review',
            component: ReviewDocumentView,
            meta: { requiresFlow: true, requiresSigningValidation: true },
        },
        {
            path: `${basePath}/esignature/envelope`,
            name: 'envelope',
            component: EsignatureEnvelopeView,
            meta: { requiresSigningValidation: true },
        },
        {
            path: `${basePath}/esignature/request-canceled`,
            name: 'request-canceled',
            component: RequestCanceledView,
            meta: { terminal: true },
        },
        {
            path: `${basePath}/esignature/request-voided`,
            name: 'request-voided',
            component: RequestVoidedView,
            meta: { terminal: true },
        },
        {
            path: `${basePath}/esignature/submit`,
            name: 'submit',
            component: EsignatureSubmitView,
        },
        {
            path: `${basePath}/esignature/complete`,
            name: 'complete',
            component: EsignatureCompleteView,
            meta: { terminal: true },
        },
        {
            path: `${basePath}/esignature/finish-later`,
            name: 'finish-later',
            component: EsignatureFinishLaterView,
            meta: { terminal: true },
        },
        {
            path: `${basePath}/esignature/decline`,
            name: 'decline',
            component: EsignatureRecipientDeclineView,
            meta: { terminal: true },
        },
        {
            path: `${basePath}/esignature/request-decline`,
            name: 'request-decline',
            component: EsignatureRequestDeclineView,
            meta: { terminal: true },
        },
        {
            path: `${basePath}/esignature/dashboard`,
            name: 'dashboard',
            component: EsignatureSuccessView,
            meta: { requiresFlow: true },
        },
        {
            path: `${basePath}/esignature/error`,
            name: 'error',
            component: EsignatureErrorView,
            meta: { terminal: true },
        },
        {
            path: `${basePath}/esignature/manual-review`,
            name: 'manual-review',
            component: ManualReviewView,
            meta: { terminal: true },
        },
    ];
};
